import { render, staticRenderFns } from "./Indications.vue?vue&type=template&id=cc1a57b8&"
import script from "./Indications.vue?vue&type=script&lang=js&"
export * from "./Indications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports